//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      searchText: null,
      search: null,
      isLoading: false,
      items: [],
      blockchain: null,
      showAlert: false,
      connectIndex: 0,
      showPreviewDialog: 0,
      selectedId: [],
      windowWidth: 0,
      showingRewards: 5,
      showingCollectors: 5,
      showingVIP: 5,
      showingRAirDrops: 5,
      sortRPrize: 0,
      sortRBuyPrice: 0,
      sortCPrize: 0,
      sortCBuyPrice: 0,
      sortVPrize: 0,
      sortVBuyPrice: 0,
      sortCollectors: 0,
      sortAirDropVPrice: 0,
      sortAirDropVBought: 0,
      panel: [],
      searchAirDrop: null,
      itemsAirDrop: [],
      searchTextAirDrop: null,
      airdropRest: 0,
      showAirdropModal: false,
      airdropTx: ""
    };
  },

  head() {
    return {
      title: "Decentral-Art Rewards",
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Browse the types of rewards. Check the wallets that have received awards. Trade picture pieces. Here you can find a real opportunity to buy a cheaper NFT token'
        }
      ]
    }
  },

  watch: {
    showAirdropModal(){
      this.airdropTx = "";
    },
    searchText(val) {
      const addresses = [];
      const tokens = [];

      if (val == '' || val == null) {
        this.items = [];
        return;
      }

      if (val.indexOf('Wallet: ') == 0) val = val.substring(8);
      if (val.indexOf('Token ID: ') == 0) val = val.substring(10);
      if (this.isLoading) return;

      this.isLoading = true;

      this.sortedRewards.map((item, i) => {
        const { token, winner, prize, sellingPrice } = item;

        if (val.length <= 5 && token == val) {
          tokens.push({
            name: 'Token ID: ' + token,
            token,
            prize,
            sellingPrice,
            winner,
            data: { type: 'token', val: token }
          });
        } else if (val.length > 5 && winner.includes(val)) {
          const found = addresses.find(element => element.name === 'Wallet: ' + winner);

          if (!found) {
            addresses.push({
              name: 'Wallet: ' + winner,
              token,
              prize,
              sellingPrice,
              winner,
              data: { type: 'wallet', val: winner.toUpperCase() }
            });
          }
        }
      });

      this.isLoading = false;

      this.items = [...tokens.slice(0, 3), ...addresses.slice(0, 3)];
    },

    searchTextAirDrop(val) {
      const airdrops = [];

      if (val == '' || val == null) {
        this.itemsAirDrop = [];
        return;
      }

      if (val.indexOf('Wallet: ') == 0) val = val.substring(8);
      if (this.isLoading) return;

      this.isLoading = true;

      this.getAirDrops.map((item, i) => {
        const { wallet, price, quantity } = item;

        if (val.length > 5 && wallet.includes(val)) {
          const found = airdrops.find(element => element.name === 'Wallet: ' + wallet);

          if (!found) {
            airdrops.push({
              name: 'Wallet: ' + wallet,
              price,
              quantity,
              wallet,
              data: { type: 'wallet', val: wallet }
            });
          }
        }
      });

      this.isLoading = false;

      this.itemsAirDrop = airdrops.slice(0, 3);
    }
  },

  computed: {
    web3() {
      return this.$store.state.web3;
    },
    getAirDrops() {
      const prices = [];
      const quantity = {};

      this.token.buyLog.map(l => {
        l.b.map(i => {
          quantity[i] = (quantity[i] || 0) + 1;
          if (typeof prices[i] == 'undefined') prices[i] = l.p;
          else prices[i] += l.p;
        });
      });
      return Object.keys(prices).map((i) => {
        return { wallet: this.token.indexes[i], price: prices[i], quantity: quantity[i] };
      });
    },

    sortedAirDrops() {
      const { searchAirDrop, itemsAirDrop } = this;

      if (searchAirDrop !== null && itemsAirDrop.length) {
        return itemsAirDrop;
      }

      return this.getAirDrops.sort((a, b) => {
        if (this.sortAirDropVPrice > 0) {
          if (this.sortAirDropVPrice == 1) return b.quantity - a.quantity;
          else return a.quantity - b.quantity;
        } else if (this.sortAirDropVBought > 0) {
          if (this.sortAirDropVBought == 1) return b.quantity - a.quantity;
          else return b.quantity - a.quantity;
        }
      });
    },

    holdingsAddresses: function () {
      return this.$store.getters['token/holdingsAddresses'];
    },

    filteredPhases: function () {
      if (this.search == null) {
        return this.token.phases;
      }

      let phases = JSON.parse(JSON.stringify(this.token.phases));

      if (this.search.data.type == 'phase') {
        return phases.filter(p => p.phase == this.search.data.val);
      } else if (this.search.data.type == 'token') {
        return phases.filter(p => {
          let index = p.ids.indexOf(this.search.data.val);
          if (index != -1) {
            p.show = p.show.map(() => false);
            p.show[index] = true;
            return true;
          } else return false;
        });
      } else if (this.search.data.type == 'wallet') {
        return phases.filter(p => {
          let found = false;
          p.buyers.map((b, bi) => {
            if (b.toUpperCase() == this.search.data.val) {
              p.show[bi] = true;
              found = true;
            } else p.show[bi] = false;
          });

          return found;
        });
      } else return phases;
    },

    sortedVIP() {
      const vip = [];
      let sellingPrice = 0;

      this.token.buyLog.map(bl => {
        bl.i.map((tId, index) => {
          if (this.token.vipIndexes.indexOf(tId) != -1) {
            sellingPrice = 0;
            for (var o = 0; o < this.token.owning.length; o++) {
              if (typeof this.token.owning[o][tId] != 'undefined') {
                sellingPrice = this.token.owning[o][tId];
                break;
              }
            }
            vip.push({
              prize: bl.p / 2,
              token: tId,
              winner: this.token.indexes[bl.b[index]],
              sellingPrice: sellingPrice
            });
          }
        });
      });

      vip.sort((a, b) => {
        if (this.sortVPrize > 0) {
          if (this.sortVPrize == 1) return b.prize - a.prize;
          else return a.prize - b.prize;
        } else if (this.sortVBuyPrice > 0) {
          if (this.sortVBuyPrice == 1) return b.sellingPrice - a.sellingPrice;
          else return a.sellingPrice - b.sellingPrice;
        } else {
          return a.token - b.token;
        }
      });

      return vip;
    },

    vipAmount() {
      let amount = 0;
      this.sortedVIP.map(v => (amount += v.prize));

      return amount;
    },

    sortedCollectors() {
      const collectors = [];
      let sellingPrice = 0;

      Object.keys(this.token.percentWinners).map(key => {
        sellingPrice = 0;

        for (var o = 0; o < this.token.owning.length; o++) {
          if (typeof this.token.owning[o][key] != 'undefined') {
            sellingPrice = this.token.owning[o][key];
            break;
          }
        }

        collectors.push({
          prize: this.token.percentWinners[key].amount,
          token: parseFloat(key),
          winner: this.token.indexes[this.token.percentWinners[key].winner],
          sellingPrice: sellingPrice
        });
      });

      collectors.sort((a, b) => {
        if (this.sortCPrize > 0) {
          if (this.sortCPrize == 1) return b.prize - a.prize;
          else return a.prize - b.prize;
        } else if (this.sortCBuyPrice > 0) {
          if (this.sortCBuyPrice == 1) return b.sellingPrice - a.sellingPrice;
          else return a.sellingPrice - b.sellingPrice;
        } else {
          return a.token - b.token;
        }
      });

      return collectors;
    },

    sortedRewards() {
      const { items, search } = this;

      if (search !== null && items.length) {
        return items;
      }

      const rewards = [];
      let sellingPrice = 0;

      this.token.buyWinners.map(w => {
        for (var i = 0; i < w.w.length; i++) {
          sellingPrice = 0;
          for (var o = 0; o < this.token.owning.length; o++) {
            if (typeof this.token.owning[o][w.t[i]] != 'undefined') {
              sellingPrice = this.token.owning[o][w.t[i]];
              break;
            }
          }

          rewards.push({
            prize: w.a,
            token: w.t[i],
            winner: this.token.indexes[w.w[i]],
            sellingPrice: sellingPrice
          });
        }
      });

      rewards.sort((a, b) => {
        if (this.sortRPrize > 0) {
          if (this.sortRPrize == 1) return b.prize - a.prize;
          else return a.prize - b.prize;
        } else if (this.sortRBuyPrice > 0) {
          if (this.sortRBuyPrice == 1) return b.sellingPrice - a.sellingPrice;
          else return a.sellingPrice - b.sellingPrice;
        } else {
          return a.token - b.token;
        }
      });

      return rewards;
    },

    token() {
      return this.$store.state.token;
    },

    blockchainData() {
      if (this.blockchain) return this.blockchain.getData();
      else return false;
    },

    showOverlay() {
      return (
        this.blockchain == null ||
        typeof this.blockchainData.actualPhase == 'undefined' ||
        this.progressValue < 100 ||
        this.blockchainData.phases > 0
      );
    }
  },

  methods: {
    disabledReceive(addr){
      if(this.web3.account != addr) return true;
      return false;
    },
    getPhase(tokenId){
      let pom = 0;
      for (var i = 0; i < 19; i++) {
        if(pom > tokenId)
          return i-1;
        else {
          pom += this.token.buyLog[i].b.length;
        }
      }
      return 18;
    },
    previewButtonLink(token){
      if(this.token.myAddressIndex > -1 && typeof this.token.owning[this.token.myAddressIndex][token] != "undefined"){// sell
        return "/after-market?sell="+token;
      } else { // buy
        return "/after-market?buy="+token;
      }
    },

    previewButtonLabel(token, price){
      if(this.token.myAddressIndex > -1 && typeof this.token.owning[this.token.myAddressIndex][token] != "undefined"){// sell
        return price === 0 ? this.$t('buttons.sell') : this.$t('buttons.change');
      } else { // buy
        return this.$t('buttons.buy');
      }
    },
    previewButtonColor(token, price){
      if(this.token.myAddressIndex > -1 && typeof this.token.owning[this.token.myAddressIndex][token] != "undefined"){// sell
        return price === 0 ? '#6200EE' : '#8F46F6';
      } else { // buy
        return '#d4af37';
      }
    },

    abc(v) {
      return ['th', 'st', 'nd', 'rd'][Math.abs(~[1, 2, 3].indexOf(+(+v).toFixed().substr(-1)))];
    },

    shortenNumber(price) {
      const number = this.$globalFn.plainString(price).toString();

      if (this.windowWidth < 500) {
        return number.substr(0, 7) + '… ';
      } else {
        return number;
      }
    },

    screenWidth(e) {
      this.windowWidth = e.currentTarget.innerWidth;
    },

    preview(a) {
      this.selectedId = [a];
      this.showPreviewDialog++;
    },

    getObject(b) {
      this.blockchain = b;
    },

    metamaskUpdated(s) {},

    blockchainEvent(error, event) {
      if (error == null) {
        this.blockchain.loadContractData();
      }
    },
    check(){
      this.$web3Call(true, 'beforeDecentralAirdrop', this.web3.account).then(info => {
        this.airdropRest = info.amount;
        this.showAirdropModal = true; 
      });
    },
    receive() {
      this.$web3Send(true, "decentralAirdrop", { from: this.web3.account },).then(res => {
        this.airdropTx = res.transactionHash;
      });
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.screenWidth);
  },

  mounted() {
    let interval = setInterval(() => {
      this.progressValue += 20;
      if (this.progressValue >= 100) {
        clearInterval(interval);
      }
    }, 100);

    window.addEventListener('resize', this.screenWidth);

    this.windowWidth = window.innerWidth;
  }
};
